export const PAGINATION_SIZE = 10;
export const PAGINATION_MAX_SIZE = 1000000000;
export const PAGINATION_FIRST_PAGE = 0;
export const PAGINATION_INITIAL_ELEMENT_COUNT = 0;
